<template>
    <modal v-model="show" max-width="1000" :has-padding="false">
        <app-integration-errors-report-modal></app-integration-errors-report-modal>

        <div class="wrapper" key="integration-report">
            <div class="checkbox-wrapper flex-center">
                <v-checkbox
                    v-model="onlyFails"
                    label="Apenas registros com falhas"
                ></v-checkbox>
            </div>

            <div class="smaller-padding data-table">
                <v-data-table
                    :headers="headers"
                    :items="list"
                    :total-items="30"
                    :loading="loading"
                    :hide-actions="true"
                    :must-sort="true"
                    :pagination.sync="sync"
                    no-data-text="Sem dados"
                    no-results-text="Sem dados"
                    sort-icon="mdi-chevron-down"
                    ref="table"
                >
                    <v-progress-linear
                        slot="progress"
                        :color="providerColor"
                        indeterminate
                    />

                    <template slot="items" slot-scope="props">
                        <app-integration-report-table-item
                            :data-item="props.item"
                            @change="load()"
                        >
                        </app-integration-report-table-item>
                    </template>
                </v-data-table>

                <v-pagination
                    v-if="totalPages"
                    v-model="sync.page"
                    color="primary"
                    :total-visible="7"
                    :length="totalPages"
                    @input="setPage"
                />
            </div>
        </div>
    </modal>
</template>

<script>
import EventBus from "@packages/event-bus/index";
import AppIntegrationReportTableItem from "./components/IntegrationReportTableItem";
import sortableTable from "@mixins/sortable-table";
import paginatedTable from "@mixins/paginated-table";
import AppIntegrationErrorsReportModal from "./components/IntegrationErrorsReportModal";
import Modal from "@/components/generic/Modal";
import provider from "@mixins/provider";

export default {
    components: {
        AppIntegrationReportTableItem,
        AppIntegrationErrorsReportModal,
        Modal,
    },

    data() {
        return {
            show: false,
            onlyFails: false,
            entity: "integrationsreport",
            orderMethod: "order",
            hook: null,
            records: [],
            headers: [
                { text: "Data", value: "dataCadastro" },
                { text: "Cliente", value: "nomeCliente" },
                { text: "E-mail", value: "emailCliente" },
                { text: "Campanha", value: "nomeCampanha" },
                { text: "Enviado", value: "enviar" },
                { text: "Erros", value: "erros" },
            ],
        };
    },
    watch: {
        onlyFails(value) {
            this.$store.commit("INTEGRATIONSREPORT_SET_FILTER", {
                key: "onlyFails",
                value: value,
            });
        },
    },
    methods: {
        resetIntegrationRepostModalHandler(hook) {
            this.hook = hook;
            this.show = true;
            this.onlyFails = false;
            this.$store.commit("INTEGRATIONSREPORT_SET_FILTER", {
                key: "hook",
                value: hook._id,
            });
            this.load();
        },
    },
    mounted() {
        EventBus.$on(
            "RESET_INTEGRATION_REPORT_MODAL",
            this.resetIntegrationRepostModalHandler
        );
    },
    beforeDestroy() {
        EventBus.$off(
            "RESET_INTEGRATION_REPORT_MODAL",
            this.resetIntegrationRepostModalHandler
        );
    },
    mixins: [paginatedTable, sortableTable, provider],
};
</script>

<style lang="scss" scoped>
.v-dialog__content {
    border-radius: 5px;
}
.modal {
    border-radius: 5px;
}

.checkbox-wrapper {
    height: 40px;
}

button {
    margin: 5px;
}

.wrapper {
    padding: 10px !important;
}

.card-footer {
    text-align: center;
}
</style>
